module.exports = __webpack_public_path__ + "static/img/834d096173a7940b402010d2a91de097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon2(2).jpg
// module id = sOO8
// module chunks = 1